if (!customElements.get('fragrance-family-links')) {
  class FragranceFamilyLinks extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.fragrance-families__list');
      this.currentLink = this.querySelector('[aria-current="page"]');
      if (!this.list || !this.currentLink) return;

      this.resizeObserver = new ResizeObserver(() => this.revealCurrentLink());
      this.resizeObserver.observe(this.list);
      document.fonts.ready.then(() => {
        if (this.isConnected) this.revealCurrentLink();
      });
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    revealCurrentLink() {
      if (this.list.scrollWidth <= this.list.clientWidth) return;
      const listBounds = this.list.getBoundingClientRect();
      const linkBounds = this.currentLink.getBoundingClientRect();
      this.list.scrollLeft += linkBounds.left - listBounds.left - (this.list.clientWidth - linkBounds.width) / 2;
    }
  }

  customElements.define('fragrance-family-links', FragranceFamilyLinks);
}